module.exports = __webpack_public_path__ + "static/media/nba.a59293ce.png";